/**
 * Ideally these are exported by @atlaskit/page
 */
export var spacing = {
  comfortable: "var(--ds-space-500, 40px)",
  cosy: "var(--ds-space-200, 16px)",
  compact: "var(--ds-space-050, 4px)"
};